import { UnidadeMedidaTempoEnum } from 'graphql/types.generated'
import { createValidator, ErrorObject, maxLength, minLength, minRange, range, required } from 'util/validation'
import { isEmpty } from 'util/validation/Util'

import { MedicamentoFormModel } from '../model-prescricao'
import {
  validateDataInicioPrescricao,
  validateFieldFracionado,
  validateMotivoPrescricao,
  validateRegistroManualOuCombo,
} from './prescricao-rules'
import { isCampoInvalido } from './utils-prescricao'
import { getValidationFrequenciaStrategy } from './validator-prescricao-freq-strategy'

export const prescricaoFormValidator = (
  dataAtendimento: Date,
  isMotivoPrescricaoEnabled: boolean,
  isRegistroTardio: boolean = false
) =>
  createValidator<MedicamentoFormModel>(
    {
      viaAdministracao: [required],
      principioAtivoText: [maxLength(200)],
      qtDose: [required, minLength(1), maxLength(5), minRange(0.01)],
      qtDoseManha: [minLength(1), maxLength(5), minRange(0.01)],
      qtDoseTarde: [minLength(1), maxLength(5), minRange(0.01)],
      qtDoseNoite: [minLength(1), maxLength(5), minRange(0.01)],
      unidadeMedidaDose: [required],
      concentracaoText: [maxLength(100)],
      dataInicioTratamento: [required],
      quantidade: [required, range(1, 999)],
      duracao: [range(1, 999)],
      recomendacoes: [maxLength(500)],
    },
    (values: MedicamentoFormModel, errors: ErrorObject<MedicamentoFormModel>) => {
      if (!values) {
        return errors
      }

      errors.qtDose = errors.qtDose ?? validateFieldFracionado(values.qtDose)

      if (values.dataInicioTratamento) {
        errors.dataInicioTratamento = validateDataInicioPrescricao(
          values.dataInicioTratamento,
          dataAtendimento,
          isRegistroTardio
        )
      }

      validateRegistroManualOuCombo(values, errors)

      if (UnidadeMedidaTempoEnum.INDETERMINADO !== values.escalaDuracao && !values.duracao) {
        errors.duracao = required(values.duracao)
      }

      if (values.usoContinuo) {
        errors.duracao = isCampoInvalido(!isEmpty(values.duracao))(values.duracao)
        errors.escalaDuracao = isCampoInvalido(values.escalaDuracao !== UnidadeMedidaTempoEnum.INDETERMINADO)(
          values.escalaDuracao
        )
      }

      const validationFrequenciaStrategy = getValidationFrequenciaStrategy(values)
      if (validationFrequenciaStrategy) {
        validationFrequenciaStrategy(values, errors)
      }

      if (isMotivoPrescricaoEnabled) {
        validateMotivoPrescricao(values, errors)
      }
      return errors
    }
  )
